<template>
  <svg
    v-if="svgCode"
    xmlns="http://www.w3.org/2000/svg"
    :viewBox="computedViewBox"
    v-html="svgCode"
    role="img"
    :width="width"
    :height="height"
    :class="['p-icon', {'p-icon--hover': hover}]"
    :style="style"
  ></svg>
</template>

<script>
import {iconsSet} from "@/domain/icon/iconSet";

export default {
  props: {
    name: {
      type: String,
      required: true
    },
    width: {
      type: [String, Number],
      required: false,
    },
    height: {
      type: [String, Number],
      required: false,
    },
    hover: {
      type: Boolean,
      required: false,
    },
    verticalAlign: {
      type: String,
      default: 'middle',
      validator: function(value) {
        return ['baseline', 'middle', 'text-bottom', 'sub', 'super', 'top'].indexOf(value) !== -1
      }
    }
  },
  data() {
    return {
      svgCode: null,
      viewBox: null
    };
  },
  computed: {
   computedViewBox() {
      return `0 0 ${this.viewBox}`
    },
    style() {
      return {
        verticalAlign: this.verticalAlign
      }
    }
  },
  watch: {
    name() {
      this.loadSvg();
    }
  },
  mounted() {
    this.loadSvg();
  },
  methods: {
    loadSvg() {
      const iconData = iconsSet[this.name]
      if (iconData) {
        const [viewBox, svgContent] = iconData
        this.viewBox = viewBox
        this.svgCode = svgContent
      } else {
        console.error(`Icon not found: ${this.name}`)
      }
    }
  }
};
</script>
